<template>
<v-form v-model="isFormValid">
<div class="d-flex">
  <div class="pr-4">
    <h5>{{ $t('billing.billingMethod') }}</h5>
    <v-select
      v-model="inputBillingMethod"
      :items="billingMethodItems"
      variant="outlined"
      density="compact"
      hide-details
    ></v-select>
  </div>

  <div v-if="billingMethod == 'hourly'" class="d-flex">
    <div class="px-4">
      <h5>{{ $t('billing.billingTime') }}</h5>
      <v-text-field
        v-model="inputHourly.billingMinute"
        :rules="[isSafeInteger, isNaturalNumber]"
        type="number"
        variant="outlined"
        density="compact"
        hide-details
        :suffix="$t('billing.perMinute')"
      ></v-text-field>
    </div>

    <div class="px-4">
      <h5>{{ $t('billing.amount') }}</h5>
      <v-text-field
        v-model="inputHourly.billingAmount"
        :rules="[isNaturalNumber]"
        type="number"
        variant="outlined"
        density="compact"
        hide-details
        :suffix="$t('billing.yen')"
      ></v-text-field>
    </div>

    <div class="px-4">
      <h5>{{ $t('billing.limit') }}</h5>
      <v-text-field
        v-model="inputHourly.billingUpperLimitAmount"
        :rules="[isNaturalNumber]"
        type="number"
        variant="outlined"
        density="compact"
        hide-details
        :suffix="$t('billing.yen')"
      ></v-text-field>
    </div>
  </div>

  <div v-else-if="billingMethod == 'monthly'" class="d-flex">
    <div class="px-4">
      <h5>{{ $t('billing.amount') }}</h5>
      <v-text-field
        v-model="inputMonthly.billingAmount"
        :rules="[isNotMinus]"
        type="number"
        variant="outlined"
        density="compact"
        hide-details
        :suffix="$t('billing.yen')"
      ></v-text-field>
    </div>
  </div>

  <div v-else>
  </div>

</div>
</v-form>
</template>

<script lang="ts">
import ValidationMixin from '@/mixins/ValidationMixin';
import { defineComponent, PropType } from 'vue'

interface Hourly {
  billingMinute: number;
  billingAmount: number;
  billingUpperLimitAmount: number;
}

interface Monthly {
  billingAmount: number;
}

export default defineComponent({
  name: 'BillingInput',

  mixins: [ValidationMixin],

  props: {
    billingMethod: {
      type: String,
      default: 'hourly',
    },
    hourly: {
      type: Object as PropType<Hourly>,
      default: () => ({
        billingMinute: 10,
        billingAmount: 0,
        billingUpperLimitAmount: 0,
      }),
    },
    monthly: {
      type: Object as PropType<Monthly>,
      default: () => ({
        billingAmount: 0
      }),
    },
    hideMonthly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // billingMethodItems: [
      //   { text: '時間あたり', value: 'hourly', },
      //   { text: '月あたり', value: 'monthly', },
      //   { text: 'グループ定額', value: 'groupFixed', },
      // ],
      isFormValid: false,
    }
  },

  computed: {
    billingMethodItems: function() {
      if (this.hideMonthly) {
        return [
          { title: this.$t('billing.hourly'), value: 'hourly', },
          { title: this.$t('billing.groupFixed'), value: 'groupFixed', },
        ];
      }
      return [
        { title: this.$t('billing.hourly'), value: 'hourly', },
        { title: this.$t('billing.monthly'), value: 'monthly', },
        { title: this.$t('billing.groupFixed'), value: 'groupFixed', },
      ];
    },
    inputBillingMethod: {
      get(): string {
        return this.billingMethod;
      },
      set(value: string) {
        this.$emit('billingMethod', value);
      }
    },
    inputHourly: {
      get(): Hourly {
        return this.hourly;
      },
      set(value: Hourly) {
        this.$emit('hourly', value);
      },
    },
    inputMonthly: {
      get(): Monthly {
        return this.monthly;
      },
      set(value: Monthly) {
        this.$emit('monthly', value);
      }
    },
  },

})
</script>